import type {
    GetStandalonePackagesRequest,
    StandalonePackage,
} from "@amzn/d16-g-client-deck-builder-typescript-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsyncAbortable } from "@react-hookz/web";

import { getCdbApiClient } from "../../api/cdbApi/cdbApi";
import { useAsyncErrorStatusNotification } from "../notifications/useAsyncErrorStatusNotification";

export interface StandalonePackagesActionProps {
    advertiserIdType: string;
    advertiserId: string;
    marketplaceId: string;
    packageNameFilters?: string[];
}
export function useStandalonePackagesAction({
    advertiserIdType,
    advertiserId,
    marketplaceId,
    packageNameFilters,
}: StandalonePackagesActionProps): [
    AsyncState<StandalonePackage[]>,
    UseAsyncActions<StandalonePackage[]>,
] {
    const request: GetStandalonePackagesRequest = {
        advertiserIdType,
        advertiserId,
        marketplaceId,
        packageNameFilters,
    };

    const [insightsState, insightsAction] = useAsyncAbortable(async () => {
        const { data } = await (
            await getCdbApiClient()
        ).getStandalonePackages(request);
        return data ?? [];
    }, []);

    useAsyncErrorStatusNotification(insightsState);

    return [insightsState, insightsAction];
}
